var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15, _rect, _rect2, _ellipse2, _path16, _rect3, _rect4, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 692.60517,
    height: 748.73305,
    viewBox: "0 0 692.60517 748.73305",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 485.38885,
    cy: 252.48956,
    r: 75.36532,
    fill: "#ff6584"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M945.81769,384.31483c.16641-.03026.29119-.14636.48489-.11681a6.42649,6.42649,0,0,0-.33042-.95413c-.23989.327-.48462.66057-.69891.9527Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440.33,506.49838a175.14542,175.14542,0,0,0,8.18151,48.41582c.114.36373.23344.722.35286,1.0858h30.53273c-.03257-.32576-.06518-.68949-.09775-1.0858-2.03588-23.40445-13.77337-165.85054.26061-190.21049C478.333,366.67987,437.96292,432.1319,440.33,506.49838Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442.621,554.9142c.25518.36373.5212.72747.79265,1.0858h22.90495c-.17373-.30946-.3746-.67319-.608-1.0858-3.784-6.82969-14.984-27.24816-25.38058-48.41582-11.17289-22.74753-21.42285-46.35825-20.55962-54.90349C419.50432,453.52218,411.77343,512.27481,442.621,554.9142Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M680.6358,558.82949a152.69422,152.69422,0,0,1-7.13276,42.20965c-.09938.3171-.20352.62947-.30763.94661h-26.6189c.0284-.284.05683-.60111.08522-.94661,1.77491-20.40436,12.00784-144.591-.2272-165.82839C647.50421,436.9336,682.69942,493.99567,680.6358,558.82949Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M678.63846,601.03914c-.22247.3171-.45439.63421-.69105.94661H657.97853c.15146-.26979.32658-.5869.5301-.94661,3.299-5.95423,13.0633-23.75536,22.12717-42.20965,9.7407-19.83164,18.67677-40.41582,17.92419-47.8657C698.79191,512.644,705.53182,563.86547,678.63846,601.03914Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M376.281,136.80622l12.41349-9.92842c-9.64348-1.06393-13.60581,4.19542-15.22744,8.35824-7.53388-3.12835-15.73541.97151-15.73541.97151l24.83709,9.01674A18.79476,18.79476,0,0,0,376.281,136.80622Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M750.16515,85.70094l12.41349-9.92842c-9.64349-1.06394-13.60582,4.19541-15.22744,8.35823-7.53388-3.12835-15.73541.97151-15.73541.97151L756.45288,94.119A18.79472,18.79472,0,0,0,750.16515,85.70094Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M932.807,478.32294q0,12.33973-.8598,24.4778a344.11238,344.11238,0,0,1-63.9225,177.14036q-7.32429,10.22205-15.38088,19.87093a347.51435,347.51435,0,0,1-46.15335,45.84547L732.91905,702.487,688.93118,599.82028s65.63153-132.8871,243.75906-130.47752Q932.80171,473.81692,932.807,478.32294Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M931.94719,502.80074a346.07669,346.07669,0,0,1-129.28867,245.9669l-68.34893-40.10281-39.00951-91.05407S758.5114,489.6277,931.94719,502.80074Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#ed7342"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M868.02469,679.9411q-7.32429,10.22205-15.38088,19.87093a346.16927,346.16927,0,0,1-133.98047,98.5269q-15.79485,6.51225-32.33281,11.48526A378.83832,378.83832,0,0,1,446.085,794.57068,347.29161,347.29161,0,0,1,274.1141,626.82443q-7.165-15.0624-12.88642-30.88915c66.52315-48.73267,197.60579-118.51464,340.4708-50.70708Q660.977,573.36289,707.5602,596.51909C786.36478,635.58166,838.81265,663.74285,868.02469,679.9411Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M852.64381,699.812a346.27989,346.27989,0,0,1-578.52971-72.9876c55.558-43.93475,183.70032-122.88789,324.32562-56.15244q54.24711,25.74625,96.86036,46.93877C778.117,658.65837,829.13192,686.55412,852.64381,699.812Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#ed7342"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M754.584,781.02614a349.545,349.545,0,0,1-35.92062,17.31279A345.06471,345.06471,0,0,1,586.7634,824.36652,346.36523,346.36523,0,0,1,310.54422,686.79824C393.1913,678.0835,621.64373,666.33287,754.584,781.02614Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M718.66334,798.33893a346.4182,346.4182,0,0,1-383.95975-82.92308C364.76475,711.00011,600.775,680.67352,718.66334,798.33893Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#ed7342"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M874.76508,286.42794v.01062C627.673,103.74667,344.57538,232.33479,342.38872,233.322v-.01063a344.99584,344.99584,0,0,1,244.37468-101.032C706.89152,132.27935,812.72137,193.49508,874.76508,286.42794Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.36385,
    cy: 330.60218,
    rx: 76.90583,
    ry: 156.91896,
    transform: "translate(-307.05272 -11.0592) rotate(-10.22048)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M372.94937,584.6377c-2.47807-187.33656-65.15818-363.14039-65.79076-364.89287l-5.71631,2.0619c.62954,1.744,62.96568,176.62681,65.43083,362.91333Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#ed7342"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 295.28883,
    y: 285.00119,
    width: 6.07788,
    height: 78.86695,
    transform: "translate(-355.86074 432.82347) rotate(-72.07888)",
    fill: "#ed7342"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 334.43768,
    y: 326.71939,
    width: 78.86966,
    height: 6.07788,
    transform: "matrix(0.78393, -0.62085, 0.62085, 0.78393, -377.64511, 227.73815)",
    fill: "#ed7342"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.49949,
    cy: 212.58899,
    rx: 83.21923,
    ry: 169.80086,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M555.512,566.15909c33.33018-199.97469.33556-399.22686-.00161-401.21457l-6.48332,1.09822c.33556,1.97807,33.14072,200.18341-.00161,399.0374Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#ed7342"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 522.71705,
    y: 232.06484,
    width: 6.57683,
    height: 85.34136,
    transform: "translate(-218.04118 533.34596) rotate(-61.8584)",
    fill: "#ed7342"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 562.76044,
    y: 291.62119,
    width: 85.34429,
    height: 6.57683,
    transform: "translate(-321.21346 244.97513) rotate(-28.15796)",
    fill: "#ed7342"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M924.67605,403.40342a634.4074,634.4074,0,0,0-95.37432-43.60576c-182.1399-65.90746-362.75132-40.50617-433.44609,53.81723,55.0167-115.55307,251.32744-151.88763,449.432-80.20569a646.92582,646.92582,0,0,1,67.58469,28.87236A343.54164,343.54164,0,0,1,924.67605,403.40342Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M678.6841,217.456l12.41349-9.92842c-9.64349-1.06393-13.60582,4.19541-15.22744,8.35824-7.53389-3.12835-15.73541.9715-15.73541.9715l24.83709,9.01675A18.79478,18.79478,0,0,0,678.6841,217.456Z",
    transform: "translate(-253.69742 -75.63348)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessState);
export default __webpack_public_path__ + "static/media/SuccessState.2685b87ab92af63280f1177259106252.svg";
export { ForwardRef as ReactComponent };